<template>
  <nuttrema-layout-content-header slot="top" theme="mobile-header">
    <p slot="center">{{ $t(_get(meta, 'title')) }}</p>

    <template slot="right">
      <div v-if="showEdit" class="content-header-item">
        <el-switch v-model="options.edit" @change="updateEdit" :active-text="$t('label.edit')"></el-switch>
      </div>
      <div v-if="showOnMobileAndTablet" class="content-header-item">
        <i class="fa fa-bars" @click="toggleSidebar"></i>
      </div>
    </template>
  </nuttrema-layout-content-header>
</template>

<script>
import * as EVENT from 'constants/event';

import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

export default {
  name: 'participant-standard-header',
  props: {
    meta: {
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    showEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    showOnMobileAndTablet: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaLayoutContentHeader,
  },
  data() {
    return {
      options: {
        edit: null,
      },
    };
  },
  methods: {
    toggleSidebar() {
      this.$emit('toggle-sidebar');
      window.Eventus.$emit(EVENT.LAYOUT_MOBILE_READY_TOGGLE_SIDEBAR);
    },
    updateEdit(value) {
      this.$emit('update:edit', value);
    },
  },
  watch: {
    edit(value) {
      this.options.edit = value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/participant/shared/participant-standard-header.vue